<template>
  <div>
    <!-- 图片上传组件辅助-->
    <el-upload
      v-show="false"
      class="avatar-uploader"
      :action="uploadUrl"
      accept="image/*"
      :on-success="uploadSuccess"
    >
    </el-upload>
    <el-button
      v-show="false"
      id='videoButton'
      @click="videoForm.show = true"
    >
    </el-button>
    <el-dialog
      :close-on-click-modal="false"
      width="50%"
      style="margin-top: 1px"
      :visible.sync="videoForm.show"
      append-to-body
    >
      <el-tabs v-model="videoForm.activeName">
        <el-tab-pane label="添加视频链接" name="first">
          <el-input
            v-model="videoForm.videoLink"
            placeholder="请输入视频链接"
            clearable
          ></el-input>
          <div
            class="submit-upload"
            @click="insertVideoLink(videoForm.videoLink)"
            >确认
          </div>
        </el-tab-pane>
        <el-tab-pane label="本地视频上传" name="second">
          <el-upload
            v-loading="loading"
            style="text-align: center"
            drag
            :action="uploadUrl"
            accept="video/*"
            :before-upload="onBeforeUploadVideo"
            :on-success="onSuccessVideo"
            :on-error="onErrorVideo"
            :multiple="false"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              文件大小不能不超过10M
            </div>
          </el-upload>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <quill-editor
      v-model="content"
      ref="myQuillEditor"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @change="onEditorChange($event)"
      @ready="onEditorReady($event)">
  </quill-editor>
  </div>
</template>

<script>
import { quillEditor, Quill } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 导入自定义样式 一定要在原插件css下面引入  (看上面修改字体字号)
import '@/assets/css/quillEditor.css'
// 导入修改字体及字号 工具栏相关配置 设置工具栏中文提示（详细内容看下边）
import { titleConfig, toolbarOptions } from '@/assets/js/quillEditor'
import Video from '@/assets/js/quillVideo'
Quill.register(Video, true)
export default {
  components: {
    quillEditor
  },
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false, // 加载loading
      // 视频上传变量
      videoForm: {
        show: false, // 显示插入视频链接弹框的标识
        videoLink: '',
        activeName: 'first'
      },
      uploadUrl: process.env.API_URL + 'common/image',
      // 富文本编辑器配置
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function (value) {
                if (value) {
                  // 调用element的图片上传组件
                  document.querySelector('.avatar-uploader input').click()
                } else {
                  this.quill.format('image', false)
                }
              },
              video: function (value) {
                document.querySelector('#videoButton').click()
              }
            }
          }
        },
        placeholder: '请输入正文',
        theme: 'snow'
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setTitleConfig()
    })
  },
  methods: {
    clickVideoButton() {
      this.videoForm.videoLink = ''
      this.activeName = 'first'
    },
    hideLoading() {
      this.loading = false
    },
    insertVideoLink(videoLink) {
      if (!videoLink) return this.$message.error('视频地址不能为空！')

      this.videoForm.show = false
      let quill = this.$refs.myQuillEditor.quill
      let length = quill.selection.savedRange.index
      // 在光标所在位置 插入视频
      quill.insertEmbed(length, 'video', {
        url: videoLink,
        controls: 'controls',
        width: '100%',
        height: 'auto',
        // poster: videoLink + '?vframe/jpg/offset/1',
        preload: 'auto'
        // preload: 'metadata'
      })
      // 调整光标到最后
      quill.setSelection(length + 1)
    },
    // el-文件上传组件
    onBeforeUploadVideo(file) {
      this.loading = true
      // let acceptArr = ['video/mp4']
      // const isVideo = acceptArr.includes(file.type)
      const isLt1M = file.size / 1024 / 1024 < 10
      // if (!isVideo) {
      //   this.hideLoading()
      //   this.$message.error('只能上传mp4格式文件!')
      // }
      if (!isLt1M) {
        this.hideLoading()
        this.$message.error(`上传文件大小不能超过 10MB!`)
      }
      return isLt1M
    },
    // 文件上传成功时的钩子
    onSuccessVideo(res) {
      this.hideLoading()
      if (res.success) {
        this.insertVideoLink(res.result)
      } else {
        this.$message.error(res.message)
      }
    },
    // 文件上传失败时的钩子
    onErrorVideo() {
      this.hideLoading()
      this.$message.error('上传失败')
    },
    uploadSuccess(res) {
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill
      // 如果上传成功
      if (res.success) {
        // 获取光标所在位置
        let length = quill.getSelection().index
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, 'image', res.result)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        // 提示信息，需引入Message
        this.$message.error('图片插入失败！')
      }
    },
    setTitleConfig() {
      for (const item of titleConfig) {
        const tip = document.querySelector('.quill-editor ' + item.Choice)
        if (!tip) continue
        tip.setAttribute('title', item.title)
      }
    },
    // 失去焦点事件
    onEditorBlur(quill) {
      console.log('editor blur!', quill)
    },
    // 获得焦点事件
    onEditorFocus(quill) {
      console.log('editor focus!', quill)
    },
    // 准备富文本编辑器
    onEditorReady(quill) {
      console.log('editor ready!', quill)
    },
    // 内容改变事件
    onEditorChange({ quill, html, text }) {
      console.log('editor change!', quill, html, text)
      this.content = html
      this.$emit('resultDesciption', html)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ql-tooltip.ql-editing{
  left: 80px !important;
}
/deep/ .el-dialog__header{
  padding:10px 0px 10px 10px
}
/deep/ .el-dialog__body{
  width: 95%;
  margin:0 auto
}
/deep/ .el-tabs__item.is-top.is-active{
  color: #262b2f !important;
  font-weight:none;
  font-family: Satoshi-Medium !important;
}
/deep/ .el-tabs__active-bar.is-top{
  background-color: #262b2f !important;
}
/deep/ .el-tabs__item.is-top{
  font-weight:none;
  font-family: Satoshi-Regular !important;
}
/deep/ .el-tabs__item:hover{
  color: #262b2f !important;
}
.submit-upload{
  margin: 10px 0px;
  height: 30px;
  width: 70px;
  background-color: #262626;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/quillEditor.vue